<template>
  <div class="my-head">
    <div class="head-part1">
      <h1 class="my-menu-title">数字生态指数平台</h1>
      <div class="my-menu-collpse" name="collpse">
        <span class="my-menu-collpse-collpse" title="隐藏侧边栏" v-if="collpsed" @click="changeCollpsed(false)">
          <el-icon class="el-icon-s-fold"></el-icon>
        </span>
        <span class="my-menu-collpse-collpse" title="展开侧边栏" v-else @click="changeCollpsed(true)">
          <el-icon class="el-icon-s-unfold"></el-icon>
        </span>
      </div>
    </div>
    <i-menu class="my-menu" mode="horizontal">
      <div class="link">
        <a :href="EXTERNAL_LINK">
          技术支持
        </a>
      </div>
      <i-submenu name="user" class="my-menu-user">
        <template slot="title">
          <i-icon type="ios-contact" />
          {{ Username }}
        </template>
        <i-menuItem class="my-menu-user-sub my-menu-user-disable" name="user-department">
          <i-icon type="md-people"></i-icon>
          技术部
        </i-menuItem>
        <i-menuItem class="my-menu-user-sub" name="user-signout" @click.native="signOut">
          <i-icon type="md-exit"></i-icon>
          退出登录
        </i-menuItem>
      </i-submenu>
      <div class="dummy"></div>
    </i-menu>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex"
import { Icon } from "element-ui"
import { KeFuMixin } from "../common/mixin"
export default {
  components: {
    "el-icon": Icon,
  },
  data() {
    return {
      EXTERNAL_LINK: process.env.VUE_APP_EXTERNAL_LINK,
    }
  },
  mixins: [KeFuMixin],
  computed: {
    ...mapState(["collpsed"]),
    Username() {
      return localStorage.getItem("avmusername")
    },
  },
  methods: {
    ...mapMutations(["changeCollpsed"]),
    // 退出登录
    async signOut() {
      const self = this
      const res = await self
        .axios({
          url: self.$store.state.baseurl + "api/system/exit",
          method: "post",
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.setCookie("login", "false")
            console.log("退出登录成功")
            self.$router.push("/login")
          }
        })
        .catch((err) => {
          alert("请求失败了", err)
        })
      console.log(res)
    },
  },
}
</script>

<style scoped>
.my-head {
  position: sticky;
  margin: 0;
  top: 0px;
  z-index: 999 !important;
  display: flex;
  height: 60px;
  background-color: #fff;
  align-items: center;
  border-bottom: 1px solid #dcdee2;
}
.head-part1 {
  text-align: left;
  flex: 1;
  margin: 0 15px;
}
.my-menu {
  flex: 1;
  font-weight: bold;
  font-size: 1.1rem;
  display: flex;
  justify-content: flex-end;
}
.dummy {
  width: 30px;
}
.my-menu-title {
  flex: 4;
  font-size: 1.7rem;
  color: #212891 !important;
  text-align: left;
  display: inline-block;
  margin-right: 10px;
}
.my-menu-collpse {
  margin-left: 10px;
  margin-right: 10px;
  flex: 1;
  font-size: 1.5rem;
  color: #057009 !important;
  text-align: left;
  display: inline-block;
}
.my-menu-collpse-collpse {
  font-size: 1.5rem;
  cursor: pointer;
}
.my-menu-collpse-collpse:hover {
  padding: 5px 0;
  background-color: #e0dbd9;
  box-shadow: 1px 1px 1px #888888;
}
.my-menu-collpse-refresh {
  margin-left: 10px;
  color: #057009;
  cursor: pointer;
  font-size: 1.5rem;
}
.my-menu-collpse-refresh:hover {
  padding: 5px 0;
  box-shadow: 1px 1px 1px #888888;
  background-color: #e0dbd9;
}
.my-menu-collpse-projectView {
  margin-left: 20px;
  font-size: 1.5rem;
  cursor: pointer;
  color: #057009;
}
.my-menu-collpse-projectView:hover {
  padding: 5px 0;
  box-shadow: 1px 1px 1px #888888;
  background-color: #e0dbd9;
}
.my-menu-user-sub {
  text-align: left;
}
.my-menu-user-disable {
  pointer-events: none;
}
.my-menu-collpse {
  font-size: 1.3rem;
}
h1:hover {
  cursor: pointer;
}
</style>
